import { Button } from "../../components/ui/button";
import { ArrowRight, Shield, FileText, Gavel, Landmark } from "lucide-react";


export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (

    <>
      <section
        id="home"
        className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden"
        style={{
          backgroundImage: `url("/heroBg.png")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}

      >
        {/* Background gradient with government theme */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-yellow-50">
          <div className="absolute inset-0 opacity-5 bg-[radial-gradient(circle_at_center,_#002855_1px,_transparent_1px)] bg-[length:60px_60px]"></div>
        </div>

        {/* Government building watermark */}
        <div className="absolute bottom-0 left-0 right-0 h-40 opacity-10">
          <svg
            viewBox="0 0 1200 200"
            className="w-full h-full fill-primary"
          >
            <path d="M200,180 L1000,180 L600,40 Z" /> {/* Parliament style dome */}
          </svg>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Content Column */}
            <div className="space-y-8">
              <div className="space-y-4">
                {/* <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
                PMRDA <span className="text-primary">1st in Maharashtra</span>{" "}
                to Introduce <span className="text-accent">Blockchain in TDR System</span>
              </h1> */}

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
  SMKC <span className="text-primary">Leading Innovation</span>{" "}
  in <span className="text-accent">Blockchain-Based Infrastructure Registry</span>
</h1>


                <p className="text-xl text-muted-foreground leading-relaxed max-w-2xl">
                Ensuring transparency, accountability, and efficiency in city infrastructure through blockchain-powered geo-tagged records.
                </p>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  size="lg"
                  onClick={() => scrollToSection("about")}
                  className="bg-primary hover:bg-primary/90 text-primary-foreground"
                >
                  How It Works
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  onClick={() => scrollToSection("explore")}
                  className="border-accent text-accent hover:bg-accent hover:text-accent-foreground"
                >
                  Explore Blockchain
                </Button>
              </div>

              {/* Trust Indicators */}
              <div className="flex items-center space-x-8 pt-4">
                <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                  <Shield className="w-5 h-5 text-green-600" />
                  <span>Fraud-Proof Bidding</span>
                </div>
                <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                  <FileText className="w-5 h-5 text-blue-600" />
                  <span>Immutable Records</span>
                </div>
                <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                  <Landmark className="w-5 h-5 text-accent" />
                  <span>Government Certified</span>
                </div>
              </div>
            </div>

            {/* Illustration Column */}
            <div className="relative">
              <div className="relative bg-gradient-to-br from-primary/10 to-accent/10 rounded-2xl p-8 backdrop-blur-sm">
                {/* Auction + Blockchain visualization */}
                <div className="space-y-6">
                  {/* Auction blocks */}
                  <div className="flex items-center justify-center space-x-4">
                    {[1, 2, 3].map((step) => (
                      <div key={step} className="relative">
                        <div className="w-16 h-16 bg-primary rounded-lg flex items-center justify-center shadow-lg">
                          <span className="text-white font-bold">
                            {step}
                          </span>
                        </div>
                        {step < 3 && (
                          <div className="absolute top-8 -right-6 w-8 h-0.5 bg-primary"></div>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Auction icons */}
                  <div className="grid grid-cols-2 gap-4 mt-8">
                    <div className="bg-white/80 rounded-lg p-4 shadow-sm">
                      <Gavel className="w-8 h-8 text-primary mb-2" />
                      <p className="text-sm font-medium">City Infrastructure</p>
                      <p className="text-xs text-muted-foreground">
                        Verified on Chain
                      </p>
                    </div>
                    <div className="bg-white/80 rounded-lg p-4 shadow-sm">
                      <Shield className="w-8 h-8 text-accent mb-2" />
                      <p className="text-sm font-medium">Digital Store</p>
                      <p className="text-xs text-muted-foreground">
                        Cryptographically Secured
                      </p>
                    </div>
                  </div>

                  {/* Government Authority */}
                  <div className="text-center mt-6">
                    <Landmark className="w-12 h-12 text-primary mx-auto mb-2" />
                    <p className="text-sm font-medium text-primary">
                      SMKC Authority
                    </p>
                  </div>
                </div>
              </div>

              {/* Floating design elements */}
              <div className="absolute -top-4 -right-4 w-8 h-8 bg-accent rounded-full opacity-60 animate-pulse"></div>
              <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-primary rounded-full opacity-40 animate-pulse delay-1000"></div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}
